module.exports = __webpack_public_path__ + "img/tu.e789cb28.png";